import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

const LIVE = '#feec67';

// Copilot "✕ Clear …" pill (Deanimate Clock Stats, Clear Output); `live` adds the yellow on-air highlight.
const ClearButton = ({ label, onClick, live = false, disabled = false, title }) => (
  <Box
    component="button"
    onClick={onClick}
    disabled={disabled}
    className="no-drag"
    title={title}
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0.75,
      height: 48,
      px: 2.25,
      borderRadius: 1.5,
      border: '1px solid',
      borderColor: live ? LIVE : 'rgba(255,255,255,0.4)',
      bgcolor: live ? 'rgba(254,236,103,0.15)' : 'transparent',
      color: live ? LIVE : '#fff',
      fontFamily: '"Barlow Condensed", sans-serif',
      fontSize: 24,
      fontWeight: 700,
      letterSpacing: 0.5,
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      transition: 'all 0.15s ease',
      '&:hover': { borderColor: LIVE, color: LIVE, bgcolor: 'rgba(254,236,103,0.12)' },
      '&:disabled': { cursor: 'default', borderColor: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.3)', bgcolor: 'transparent' },
    }}
  >
    {live && <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: LIVE, boxShadow: `0 0 6px ${LIVE}` }} />}
    ✕ {label}
  </Box>
);

ClearButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  live: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

export default ClearButton;
